var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"mod-image-holder"},_vm._l((_vm.photos),function(photo,i){return _c('li',{key:i},[_c('preview-job-picture',_vm._g({attrs:{"photo-id":photo.id,"alt":photo.caption,"caption":photo.caption}},_vm.$listeners))],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }